import { render, staticRenderFns } from "./c-breadcrumbs.vue?vue&type=template&id=5bd3798d&scoped=true&"
import script from "./c-breadcrumbs.vue?vue&type=script&lang=js&"
export * from "./c-breadcrumbs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bd3798d",
  null
  
)

export default component.exports